import { DateTime } from "luxon";
import { ScheduleDto } from "../dto/schedule-dto";
import TSUlid from "../../../../types/ts-ulid";
import { ScheduleStatusEnum } from "../../../../types/enum/schedule-status-enum";

export interface ScheduleDefinition extends Omit<ScheduleDto, "id"> {
  id: TSUlid;
}

const statusNameMap: Record<ScheduleStatusEnum, string> = {
  [ScheduleStatusEnum.home]: "Home",
  [ScheduleStatusEnum.delay]: "Delayed",
  [ScheduleStatusEnum.away]: "Away",
  [ScheduleStatusEnum.urgent]: "Urgent",
};

export class Schedule implements ScheduleDefinition {
  public readonly id: TSUlid;
  public readonly status: ScheduleStatusEnum;

  // Client side properties
  private readonly date: Date;

  protected constructor(obj: ScheduleDefinition) {
    const { status, id } = obj;
    this.id = id;
    this.status = status;
    this.date = this.id.date;
  }

  public static create(obj: ScheduleDefinition): Schedule {
    return new Schedule(obj);
  }

  public static fromDto(dto: ScheduleDto): Schedule {
    const { id } = dto;
    return Schedule.create({
      ...dto,
      id: TSUlid.create(id),
    });
  }

  public get dayOfWeek(): string {
    return DateTime.fromJSDate(this.date).weekdayShort!;
  }

  public get formattedShortDate(): string {
    return DateTime.fromJSDate(this.date).toFormat("L/dd");
  }

  public get formattedForScheduleEntry(): string {
    return DateTime.fromJSDate(this.date).toFormat("EEEE M/dd");
  }

  public get formattedStatus(): string {
    return statusNameMap[this.status];
  }

  public get isAway(): boolean {
    return this.status === ScheduleStatusEnum.away;
  }

  public get isDelay(): boolean {
    return this.status === ScheduleStatusEnum.delay;
  }

  public get isOpen(): boolean {
    return this.status === ScheduleStatusEnum.home;
  }
}
